var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"12","height":"12","viewBox":"0 0 8 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 3.42857H8V4.57143H0V3.42857Z","fill":"#26BC2C"}}),_c('path',{attrs:{"d":"M4.57143 4.99557e-08L4.57143 8H3.42857L3.42857 0L4.57143 4.99557e-08Z","fill":"#26BC2C"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }